import React from "react";

/**
 * Rol & kapsam çubuğu (artifact `.scope`).
 * Role is informational (comes from auth); şube select drives the
 * app-wide organization selection (AppContext).
 */
const ROLE_LABELS = {
  super_admin: "Genel Admin — tüm organizasyonlar",
  organization_manager: "Yönetici",
  trainer: "Eğitmen",
  student: "Üye",
};

const FinanceScope = ({ userRole, organizations, selectedOrgId, onOrgChange, note }) => {
  const orgOptions = (organizations || []).filter((o) => o.id && o.id !== "all");
  const hasAll = (organizations || []).some((o) => o.id === "all");
  const locked = userRole !== "super_admin" && orgOptions.length <= 1;

  return (
    <div className="bg-[var(--fin-card)] border border-[var(--fin-line)] rounded-[14px] px-3 py-2.5 mb-3">
      <div className="flex gap-2 items-center">
        <label className="w-16 shrink-0 text-[10.5px] font-semibold text-[var(--fin-muted)] uppercase tracking-[0.06em]">
          Rol
        </label>
        <div className="flex-1 min-w-0 text-[12.5px] font-medium px-2.5 py-[7px] rounded-[9px] bg-[var(--fin-chipbg)] border border-[var(--fin-line)] text-[var(--fin-text)] truncate">
          {ROLE_LABELS[userRole] || userRole || "—"}
        </div>
      </div>
      <div className="flex gap-2 items-center mt-2">
        <label
          htmlFor="fin-org-select"
          className="w-16 shrink-0 text-[10.5px] font-semibold text-[var(--fin-muted)] uppercase tracking-[0.06em]"
        >
          Şube
        </label>
        <select
          id="fin-org-select"
          value={selectedOrgId || ""}
          disabled={locked}
          onChange={(e) => onOrgChange(e.target.value)}
          className="flex-1 min-w-0 text-[12.5px] font-medium px-2.5 py-[7px] rounded-[9px] bg-[var(--fin-chipbg)] border border-[var(--fin-line)] text-[var(--fin-text)] outline-none disabled:opacity-70 cursor-pointer disabled:cursor-default"
        >
          {hasAll && <option value="all">Tümü (konsolide)</option>}
          {orgOptions.map((o) => (
            <option key={o.id} value={o.id}>
              {o.name}
            </option>
          ))}
        </select>
      </div>
      {note && (
        <div className="mt-2 text-[10.5px] px-2.5 py-1.5 rounded-lg bg-[var(--fin-blue-soft)] text-[var(--fin-blue)]">
          {note}
        </div>
      )}
    </div>
  );
};

export default FinanceScope;
